module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true
      }
    }],
    staticClass: "pay-page"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('span', {
    staticClass: "explain"
  }, [_vm._v("请先支付主播录制费用")]), _vm._v(" "), _c('span', [_vm._v("预计字数: " + _vm._s(_vm.payInstance.totalWords) + " 字")]), _vm._v(" "), _c('span', [_vm._v("演播时长: " + _vm._s(_vm.payInstance.totalDuration) + " 小时")]), _vm._v(" "), _c('span', [_vm._v("任务酬劳: " + _vm._s(_vm.payInstance.unitPrice.direct.multiplier) + _vm._s(_vm.payInstance.unitPrice.direct.name))]), _vm._v(" "), _c('span', [_vm._v("预计总酬劳: " + _vm._s(_vm.payInstance.amount) + _vm._s(_vm.payInstance.unitPrice.direct.name))])]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.postData)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getAjaxInfo
    }
  }, [_vm._v(_vm._s(_vm.$t('comb.toPay')))])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b3403930!./~/vue-loader/lib/selector.js?type=template&index=0!./views/copyrighter/pay/ToPayPage.vue
// module id = 1091
// module chunks = 0